import React from 'react';
import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import type { CashReportCompanyLookup } from './cashReportCompaniesLookupMapper';
import { mapCompanyToCashReportLookup } from './cashReportCompaniesLookupMapper';

export const useGetCashReportCompaniesLookupQuery = (options?: { skip?: boolean }): {
  companies: CashReportCompanyLookup[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useGetCompaniesQuery(undefined, { skip: options?.skip });

  const companies = React.useMemo(
    (): CashReportCompanyLookup[] =>
      (data ?? [])
        .map(mapCompanyToCashReportLookup)
        .filter((item): item is CashReportCompanyLookup => item !== undefined)
        .sort((a, b) => a.name.localeCompare(b.name, 'pl')),
    [data]
  );

  return {
    companies,
    isLoading,
  };
};
